import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import SummaryApi from '../common'
import VerticalCard from '../components/VerticalCard'
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

const SearchProduct = () => {
    const query = useLocation()
    const [data,setData] = useState([])
    const [loading,setLoading] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false);
    const navigate = useNavigate();
    const user = useSelector(state => state?.user?.user);

    const fetchProduct = async()=>{
        setLoading(true)
        const response1 = await fetch(SummaryApi.searchProduct.url+query.search)
        const response2 = await fetch(SummaryApi.searchCosmeticProduct.url+query.search)
        const dataResponse1 = await response1.json()
        const dataResponse2 = await response2.json()
        const combinedData = [
          ...(dataResponse1.data || []),
          ...(dataResponse2.data || [])
      ]

      
        setLoading(false)

        setData(combinedData)
    }

    useEffect(()=>{
        fetchProduct()
    },[query])


    useEffect(() => {
      setLoadingPage(true);
      if (user) {
          if (user?.role === ROLE.ADMIN) {
              if (user?.type === "Medicine") {
                  navigate("/admin-home");
                  setLoadingPage(false);
              } 
              else if(user?.type === "Cosmetic") {
                  navigate("/admin-cosmetic-home");
                  setLoadingPage(false);
              }
              else if (user?.type ==="Admin"){
                  navigate("/admin-panel/all-users");
                  setLoadingPage(false);
              }
              
          } 
          else {
            setLoadingPage(false);
          }
      } else {
        setLoadingPage(false);
      }
  }, [user, navigate]);
  
  if (loadingPage) {
      return (
          <div className="flex justify-center items-center h-screen">
              <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
      );
  }

  return (
    <div className='container mx-auto p-4'>
      {
        loading && (
          <p className='text-lg text-center '>... جارى التحميل</p>
        )
      }
 
      <p className='text-xl font-semibold text-right'> {data.length} : نتائج البحث</p>

      {
        data.length === 0 && !loading && (
           <p className='bg-white text-lg text-center p-4'>...لم يتم العثور علي بيانات </p>
        )
      }


      {
        data.length !==0 && !loading && (
          <VerticalCard loading={ loading} data={data}/>
        )
      }

    </div>
  )
}

export default SearchProduct